import type { HelpFile } from '../../types/help'
import { RestrictionRuleViolationsDashboardTestIds } from '../../../testids/RestrictionRuleViolationsDashboardTestIds'

export const restrictionRuleViolationsDashboardHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rules',
  texts: {
    [RestrictionRuleViolationsDashboardTestIds.violationsDashboard]: 'Identities currently violating one or more restriction rules — holding access profiles that must not be combined.',
    [RestrictionRuleViolationsDashboardTestIds.colDeniedProfiles]: 'Denied access profiles the identity currently holds.',
    [RestrictionRuleViolationsDashboardTestIds.colDetectedAt]: 'When the violation was first detected.',
    [RestrictionRuleViolationsDashboardTestIds.colName]: null,
    [RestrictionRuleViolationsDashboardTestIds.colRuleName]: 'Restriction rule this identity is currently violating.',
  },
}
